import axiosCall from './interceptor';
import URL from '../helper';

export const getTemplatesName = async () => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}getTemplatesName`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const fetchFiles = async (data) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}fetchFiles?`;
  const response = await axiosCall('get', url, data);
  return response.data;
}

export const deleteFiles = async (data) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}deleteFiles?${
  data.environment ? `environment=${data.environment}&` : ''
  }${data.fileType ? `fileType=${data.fileType}&` : ''
  }${data.fromDate ? `fromDate=${data.fromDate}&` : ''
  }${data.ids ? `ids=${data.ids}&` : ''
  }${data.teamIds ? `teamIds=${data.teamIds}&` : ''
  }${data.templateIds ? `templateIds=${data.templateIds}&` : ''
  }${data.toDate ? `toDate=${data.toDate}&` : ''}`;
  const response = await axiosCall('delete', url, data);
  return response.data;
}
export const getGroupPermissionForUsers = async () => {
  let url = `${URL.BASE_URL}rgrouppermissionForUser`;
  let response = await axiosCall('get', url);
  return response.data;
};
export const getStorageSpace = async () => {
  let url = `${URL.BASE_URL}fetchStorageMetrics`;
  let response = await axiosCall('get', url);
  return response.data;
};